import { useQueryClient } from '@tanstack/react-query';

import { Flex } from '@/components/base';
import FeedbackGalleryEdit from '@/features/(dashboard)/feedback-gallery/ui/feedback-gallery-edit';
import { Dashboard2ColumnType } from '@/features/Dashboard/types/constants';
import type {
  Dashboard2ColumnT,
  FeedbacksSettingT,
} from '@/features/Dashboard/types/types';
import service from '@/services/index';
import useDashboard2Store from '@/stores/Dashboard2Store';
import { useToast } from '@/stores/pure/ToastStore';

import DashboardCardStyles from './styles/DashboardCardStyles';

const { StyledDashboardCardWrapper, StyledDashboardCard } = DashboardCardStyles;

type PendingFeedbackGalleryRowProps = {
  dashboardId: string;
  rowIndex: number;
  feedbacksSetting: FeedbacksSettingT;
};

const PendingFeedbackGalleryRow = ({
  dashboardId,
  rowIndex,
  feedbacksSetting,
}: PendingFeedbackGalleryRowProps) => {
  const queryClient = useQueryClient();
  const addToast = useToast();
  const setPendingFeedbackGallery = useDashboard2Store(
    (state) => state.setPendingFeedbackGallery,
  );
  const setEditingState = useDashboard2Store((state) => state.setEditingState);
  const globalFilter = useDashboard2Store((state) => state.globalFilter);
  const globalDateFilter = useDashboard2Store((state) => state.globalDateFilter);

  const handleDone = async (setting: FeedbacksSettingT) => {
    const feedbackGalleryColumn: Dashboard2ColumnT<Dashboard2ColumnType.DASHBOARD_COLUMN_FEEDBACK_GALLERY> =
      {
        type: Dashboard2ColumnType.DASHBOARD_COLUMN_FEEDBACK_GALLERY,
        feedbacks_setting: setting,
      };

    try {
      await service.dashboard2.addDashboardRow(dashboardId, {
        pos: rowIndex,
        columns: [feedbackGalleryColumn],
      });
      queryClient.invalidateQueries({
        queryKey: ['dashboard2', dashboardId],
      });
      addToast('Feedback gallery created', 'success');
    } catch (e) {
      addToast('Failed to create feedback gallery.', 'fail');
    }
    // pending 상태 클리어
    setPendingFeedbackGallery(null);
    setEditingState(false);
  };

  const handleCancel = () => {
    // pending 상태 클리어 (API 호출 없이 제거)
    setPendingFeedbackGallery(null);
    setEditingState(false);
  };

  return (
    <Flex style={{ padding: '0 12px' }}>
      <StyledDashboardCardWrapper isDragging={false} width="100%">
        <StyledDashboardCard className="h-full">
          <FeedbackGalleryEdit
            feedbacksSetting={feedbacksSetting}
            columnId=""
            onDone={handleDone}
            onCancel={handleCancel}
            globalFilter={globalFilter}
            globalDateFilter={globalDateFilter}
          />
        </StyledDashboardCard>
      </StyledDashboardCardWrapper>
    </Flex>
  );
};

export default PendingFeedbackGalleryRow;
